import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";

const CWOpenDrawer = (trigger = "sale") => {
  if (window.electronAPI?.hardware?.openDrawerConfigured) {
    window.electronAPI.hardware.openDrawerConfigured(trigger);
    return;
  }

  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;

  let openDrawerPayload = {
    cash_drawer: {
      action: "open",
    },
  };
  Axios.post(`${printerURL}printer`, openDrawerPayload, {
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  })
    .then(() => {
    })
    .catch((response) => {
    });
};

export default CWOpenDrawer;
